import React, { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import FAQ from "@/pages/FAQ";
import { LanguageProvider } from "@/lib/i18n";

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            // Wait for DOM to render, then smooth-scroll to the element
            const id = hash.replace("#", "");
            const t = setTimeout(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 60);
            return () => clearTimeout(t);
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <ScrollManager />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="*" element={<Home />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
